/*
* @Author: hasee
* @Date:   2016-11-18 11:50:27
* @Last Modified by:   hasee
* @Last Modified time: 2016-12-09 10:08:55
*/
const env = location.host.split('.')[0].match(/(qc|box)\d?/g);
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : '';
const _domain = `//wx${spell}.xinli001.com`;
const LXDOMAIN = `//lingxi${spell}.xinli001.com/lingxi/service/`;
const APIS = {
	'isTested': _domain + '/StaticApi/animal/isTested',						//判断是否做过题目
	'questions': _domain + '/StaticApi/animal/lists',							//拉取题目
	'funreport': _domain + '/StaticApi/animal/create',						//提交报告
	'unlockReport': _domain + '/StaticApi/animal/reportRelease',  //解锁报告
	'unlockPeople': _domain + '/StaticApi/animal/statistics',     //统计解锁人数api
	'sharereport': _domain + '/StaticApi/animal/shareReport',			//获取分享报告
	'getSelfReport': _domain + '/StaticApi/animal/getSelfReport',	//获取自己的趣味报告
	/**
	 * 2017/0815 LinWeiLong
	 * 获取微信JSSDK初始化信息，改用灵犀的接口
	 */
	'wechatData': `${LXDOMAIN}wx/jsConfig`,		//微信JSSDK初始化信息
	// 'shouquan': _domain + '/www/ChannelTest/authorization.html',	//微信授权
	'shouquan': _domain + '/staticApi/common/authorization.html',	//微信授权
	'tagclick': _domain + '/StaticApi/animal/tagclick',						//点击标签
	'buyProReport': _domain + '/StaticApi/order/createFreeOrder',    //购买专业报告
	'proreport': _domain + '/StaticApi/animal/getReport',					//获取专业报告
	'friends': _domain + '/StaticApi/animal/friendReport',				//获取好友列表
	'pay': _domain + '/StaticApi/freeTestOrder/payorder.html'			//获取订单信息
}


export default APIS



// WEBPACK FOOTER //
// ./src/apis.js